import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(agro_exporter_id, page, per_page) {
    return RequesterV1.get(
      `agro_exporter/providers/producers/${agro_exporter_id}/fetch_producers?current_page=${page}&rows_per_page=${per_page}`
    );
  },
};
